import { useEffect, useRef, useState } from "react";

export function useReportDetail<T>(load: () => Promise<T>, rowKey: string, failureMessage: string) {
    const [detail, setDetail] = useState<T | null>(null);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const loadRef = useRef(load);
    const failureRef = useRef(failureMessage);
    loadRef.current = load;
    failureRef.current = failureMessage;

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            setLoading(true);
            setError(null);
            try {
                const result = await loadRef.current();
                if (!cancelled) setDetail(result);
            }
            catch {
                if (!cancelled) setError(failureRef.current);
            }
            finally {
                if (!cancelled) setLoading(false);
            }
        };

        run();

        return () => { cancelled = true; };
    }, [rowKey]);

    return { detail, isLoading, error };
}
